import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

// Componentes
import { DireccionFormComponent } from '../shared/direccion-form/direccion-form.component';
import { ContactoFormComponent } from '../shared/contacto-form/contacto-form.component';

import { Contacto } from '../../../models/contacto';
import { Direccion } from '../../../models/direccion';
import { SweetAlertService } from '../../../services/sweet-alert.service';
import { TipoDeMensajeSwal } from '../../../models/enums/tipo-de-mensaje-swal';
import { AuthService } from '../../../services/auth.service';
import { HttpGenericService } from 'src/app/services/http-generic.service';
import { TipoDePersonaEnum } from 'src/app/models/enums/tipo-de-persona';
import { TipoDeCuentaEnum } from 'src/app/models/enums/tipo-de-cuenta';

@Component({
  selector: 'app-inscripcion-form',
  templateUrl: './inscripcion-form.component.html',
  styleUrls: ['./inscripcion-form.component.css']
})
export class InscripcionFormComponent implements OnInit {

  bsModalRef: BsModalRef;
  submitted = false;

  form: FormGroup;
  direcciones: Direccion[] = [];
  contactos: Contacto[] = [];
  processing: boolean = false;

  sucursales = [];
  tiposDePersonas = [];
  tiposDeIdentificacion = [];
  tiposDeProveedor = [];
  actividades = [];
  tiposDeCuenta = [];
  bancos = [];
  sesion: any;

  constructor(
    private fb: FormBuilder,
    private httpGeneric: HttpGenericService,
    private modalService: BsModalService,
    private swal: SweetAlertService,
    private auth: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.sesion = this.auth.obtenerSesionUsuario();
    let editando = false;
    if (this.sesion) {
      this.getProveedorPorId(this.sesion.code_ter);
      editando = true;
    }

    this.construirFormulario(editando);

    this.getSucursales();
    this.getTiposDePersona();
    this.getTiposDeIdentificacion();
    this.getTiposDeProveedor();
    this.getTiposDeCuenta();
    this.getBancos();
  }

  getSucursales() {
    this.httpGeneric.get('sucursales')
      .subscribe(data => {
        this.sucursales = data;
      }, err => {
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
      });
  }

  getTiposDePersona() {
    this.httpGeneric.get('tiposdepersonas')
      .subscribe(data => {
        this.tiposDePersonas = data;
      }, err => {
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
      });
  }

  getTiposDeIdentificacion() {
    this.httpGeneric.get('tiposdeidentificacion')
      .subscribe(data => {
        this.tiposDeIdentificacion = data;
      }, err => {
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
      });
  }

  getTiposDeProveedor() {
    this.httpGeneric.get('tiposdeproveedores')
      .subscribe(data => {
        this.tiposDeProveedor = data;
      }, err => {
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
      });
  }

  getActividadesPorTipoDeProveedor(id: number) {
    this.httpGeneric.get(`actividadeseconomicas/tiposdeproveedores/${id}`)
      .subscribe(data => {
        this.actividades = data;
      }, err => {
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
      });
  }

  getBancos() {
    this.httpGeneric.get('bancos')
      .subscribe(data => {
        this.bancos = data;
      }, err => {
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
      });
  }

  getTiposDeCuenta() {
    this.httpGeneric.get('tiposdecuentas')
      .subscribe(data => {
        this.tiposDeCuenta = data;
      }, err => {
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
      });
  }

  getProveedorPorId(id: number) {
    this.httpGeneric.get(`proveedores/${id}`)
      .subscribe(data => {
        this.getActividadesPorTipoDeProveedor(data.idTipoDeProveedor);
        this.getDocumentosPorTipoDePersona(data.idTipoDePersona, data.documentos);

        this.direcciones = data.direcciones;
        this.contactos = data.contactos;

        console.log(data);
        console.log(this.actividades);

        this.form.patchValue({
          idTercero: data.idTercero,
          idProveedor: data.idProveedor,
          sucursales: data.sucursalesAProveer,
          razonSocial: data.razonSocial || '',
          nombres: data.nombres || '',
          apellidos: data.apellidos || '',
          tipoDePersona: data.idTipoDePersona,
          tipoDeIdentificacion: data.idTipoDeIdentificacion,
          numeroIdentificacion: data.numeroIdentificacion,
          declarante: data.esDeclarante,
          representanteLegal: data.representanteLegal,
          identificacionRepresentante: data.numeroIdentificacionRepresentanteLegal,
          tipoDeProveedor: data.idTipoDeProveedor,
          actividades: data.actividadesEconomicas,
          codigoCiu: data.codigoCIU,
          pasivoCorriente: data.pasivoCorriente,
          activoCorriente: data.activoCorriente,
          cuentaBancaria: data.cuentaBancaria,
          tipoDeCuenta: data.idTipoDeCuenta,
          banco: data.idBanco
        });

        data.correos.forEach(e => {
          this.agregarCorreo(e.id, e.correo, e.esPrincipal);
        });

        data.telefonos.forEach(e => {
          this.agregarTelefono(e.id, e.tipo, e.numero, e.esPrincipal);
        });

      }, err => {
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
      });
  }

  get f() {
    return this.form.controls;
  }

  construirFormulario(editando?: boolean) {
    this.form = this.fb.group({
      idTercero: 0,
      idProveedor: 0,
      sucursales: [[], Validators.required],
      razonSocial: ['', [Validators.minLength(3), Validators.maxLength(300)]],
      nombres: ['', [Validators.minLength(3), Validators.maxLength(100)]],
      apellidos: ['', [Validators.minLength(3), Validators.maxLength(100)]],
      tipoDePersona: [null, Validators.required],
      tipoDeIdentificacion: [null, Validators.required],
      numeroIdentificacion: ['', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(100),
        Validators.pattern('[0-9]*')]
      ],
      declarante: [null, Validators.required],
      representanteLegal: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(200)]],
      identificacionRepresentante: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100), Validators.pattern('[0-9]*')]],
      pasivoCorriente: [null, [Validators.required, Validators.maxLength(13), Validators.pattern('[0-9]*')]],
      activoCorriente: [null, [Validators.required, Validators.maxLength(13), Validators.pattern('[0-9]*')]],
      tipoDeProveedor: [null, Validators.required],
      actividades: [[], Validators.required],
      codigoCiu: ['', [Validators.required, Validators.maxLength(100)]],
      cuentaBancaria: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100), Validators.pattern('[0-9]*')]],
      tipoDeCuenta: [null, Validators.required],
      banco: [null, Validators.required],
      correos: this.fb.array(editando ? [] : [this.crearItemCorreo()]),
      telefonos: this.fb.array(editando ? [] : [this.crearItemTelefono()]),
      documentos: this.fb.array([]),
      politicaProteccionDatos: [false, Validators.required]
    });

    this.formControlValueChanged();
  }

  formControlValueChanged() {
    const controlNombres = this.form.get('nombres');
    const controlApellidos = this.form.get('apellidos');
    const controlRazonSocial = this.form.get('razonSocial');

    this.form.get('tipoDePersona').valueChanges.subscribe(
      (value: number) => {
        if (value == 1) {
          controlNombres.setValidators([Validators.required]);
          controlApellidos.setValidators([Validators.required]);
          controlRazonSocial.clearValidators();
        }
        else if (value == 2) {
          controlNombres.clearValidators();
          controlApellidos.clearValidators();
          controlRazonSocial.setValidators([Validators.required]);
        }

        controlNombres.updateValueAndValidity();
        controlApellidos.updateValueAndValidity();
        controlRazonSocial.updateValueAndValidity();
      });
  }

  agregarCorreo(id?: number, correo?: string, esPrincipal?: boolean) {
    this.correos.push(this.crearItemCorreo(id, correo, esPrincipal));
  }

  crearItemCorreo(id?: number, correo?: string, esPrincipal?: boolean) {
    return this.fb.group({
      id: id || 0,
      correo: [correo || '', [Validators.required, Validators.maxLength(100), Validators.email]],
      esPrincipal: esPrincipal || false
    });
  }

  removerCorreo(index: number) {
    this.correos.removeAt(index);
  }

  get correos(): FormArray {
    return this.form.get('correos') as FormArray;
  }

  agregarTelefono(id?: number, tipo?: string, numero?: number, esPrincipal?: boolean) {
    this.telefonos.push(this.crearItemTelefono(id, tipo, numero, esPrincipal));
  }

  crearItemTelefono(id?: number, tipo?: string, numero?: number, esPrincipal?: boolean) {
    return this.fb.group({
      id: id || 0,
      tipo: [tipo || '', Validators.required],
      numeroTelefonico: [numero || '', [Validators.required, Validators.maxLength(50)]],
      esPrincipal: esPrincipal || false
    });
  }

  removerTelefono(index: number) {
    this.telefonos.removeAt(index);
  }

  get telefonos(): FormArray {
    return this.form.get('telefonos') as FormArray;
  }

  get documentos(): FormArray {
    return this.form.get('documentos') as FormArray;
  }

  getDocumentosPorTipoDePersona(id: number, documentos?: Array<string>) {
    this.limipiarFormArrayDocumentos();

    this.httpGeneric.get(`tiposdepersonas/${id}/tiposdedocumentos`)
      .subscribe((data: any) => {
        data.forEach((d, i) => {
          this.documentos.push(
            this.fb.group({
              id: d.id,
              nombre: d.nombre,
              rutaArchivo: documentos ? documentos[i] : null,
              archivo: [null, documentos ? null : Validators.required],
              formatoPermitido: d.formato,
              tamano: d.tamano
            })
          )
        });
      }, err => {
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
      });
  }

  limipiarFormArrayDocumentos() {
    while (this.documentos.length !== 0) {
      this.documentos.removeAt(0);
    }
  }

  guardar() {
    this.submitted = true;
    let mensajesDeValidacion = this.validarInformacionRequerida();

    if (mensajesDeValidacion.trim().length > 0) {
      this.swal.mostrarMensajeHtml(TipoDeMensajeSwal.Warning, '¡Faltan datos por completar!', mensajesDeValidacion);
      return;
    }

    if (this.form.invalid) {
      return;
    }

    let formData = new FormData();
    let formModel = this.form.value;

    formData.append('idTercero', formModel.idTercero);
    formData.append('idProveedor', formModel.idProveedor);

    formModel.sucursales.forEach(e => {
      formData.append('sucursales', e);
    });

    formData.append('nombres', formModel.nombres);
    formData.append('apellidos', formModel.apellidos);
    formData.append('razonSocial', formModel.razonSocial);
    formData.append('idTipoDePersona', formModel.tipoDePersona);
    formData.append('idTipoDeIdentificacion', formModel.tipoDeIdentificacion);
    formData.append('numeroIdentificacion', formModel.numeroIdentificacion);
    formData.append('esDeclarante', formModel.declarante);
    formData.append('representanteLegal', formModel.representanteLegal);
    formData.append('identificacionRepresentante', formModel.identificacionRepresentante);
    formData.append('pasivoCorriente', formModel.pasivoCorriente);
    formData.append('activoCorriente', formModel.activoCorriente);
    formData.append('idTipoDeProveedor', formModel.tipoDeProveedor);

    formModel.actividades.forEach(e => {
      formData.append('actividades', e.id);
    });

    formData.append('codigoCIU', formModel.codigoCiu);
    formData.append('cuentaBancaria', formModel.cuentaBancaria);
    formData.append('idTipoDeCuenta', formModel.tipoDeCuenta);
    formData.append('idBanco', formModel.banco);
    
    this.adjuntos.forEach(e => {
      formData.append('documentos', e);
    });

    formData.append('correos', JSON.stringify(formModel.correos));
    formData.append('telefonos', JSON.stringify(formModel.telefonos));
    formData.append('contactos', JSON.stringify(this.contactos));
    formData.append('direcciones', JSON.stringify(this.direcciones));

    let mensaje = `<p style="text-align: justify;font-size: 10px;">De acuerdo a la Ley 1581 de 2012 y al Decreto 1377 de 2013, por medio del presente documento autorizo u otorgo de manera voluntaria mi consentimiento previo, expreso e informado a EL POBLADO S.A. para que mis datos personales privados (como email, teléfono, dirección, etc.) que le he revelado, sean usados para: 1. obtener ofertas comerciales de servicios y productos y 2. recibir noticias e información sobre promociones y productos; los cuales podrán ser objeto de recolección, almacenamiento, uso, circulación, transferencia o supresión (el "Tratamiento"), en los términos y con los estándares de seguridad por las personas y fines que se indican en la Política de Tratamiento de la Información de EL POBLADO S.A. (la "Política"), la cual puede ser consultada en www.grupoelpoblado.com/politicas. La autorización se otorga para datos personales que se traten en el futuro con estos mismos fines. Manifiesto que se me informaron los derechos que me asisten de acuerdo a la Constitución y la Ley, en especial el de conocer, actualizar, rectificar y suprimir mi información otorgada, así como el de revocar este consentimiento. RESPONSABLE Y DATOS DE CONTACTO: EL POBLADO S.A. con domicilio principal en la Carrera 49 No. 74 - 157 en Barranquilla – Atlántico, Colombia, teléfono: +57 (5) 3852827. A través del correo electrónico servicioalclientebaq@grupoelpoblado.com podrán radicar los requerimientos relacionados con la protección de los datos personales.</p>
      <p class="text-center"><a href="https://www.elpobladosa.com/politicas.pdf" target="_blank">Ver manual de política de tratamiento de datos</a></p>`;
    this.swal.mensajeConfirmacionHtml(TipoDeMensajeSwal.Info, 'Política de protección de Datos', mensaje)
      .then(resultado => {
        if (resultado.value) {
          this.swal.mensajeConfirmacion(TipoDeMensajeSwal.Question, 'Los datos se enviarán a El Poblado S.A para su validación, ¿Desea continuar con el proceso?', '')
            .then(resultado => {
              if (resultado.value) {
                this.processing = true;
                let url;

                if (this.sesion) {
                  url = this.httpGeneric.put(`proveedores/${formModel.idTercero}`, formData);
                }
                else {
                  url = this.httpGeneric.post('proveedores', formData);
                }

                url
                  .subscribe(data => {
                    this.processing = false;
                    this.swal.mostrar(TipoDeMensajeSwal.Success, data.mensaje, '');
                    this.auth.cerrarSesion();
                    this.auth.estaLogueado.next(false);
                    this.router.navigateByUrl('');
                  }, (err) => {
                    this.processing = false;
                    if (err.status === 400) {
                      this.swal.mostrar(TipoDeMensajeSwal.Warning, 'Inscripción Invalida', err.error.mensaje);
                    }
                    if (err.status === 500) {
                      this.swal.mostrar(TipoDeMensajeSwal.Error, 'Error', 'Ha ocurrido un error al procesar los datos, intentelo mas tarde');
                    }
                  })
              }
            });
        }
      });
  }

  mensajesValidacion = {
    "sucursales": "Seleccione al menos una sucursal",
    "nombres": "Ingrese sus nombres",
    "apellidos": "Ingrese sus apellidos",
    "razonSocial": "Ingrese la razón social",
    "tipoDePersona": "Seleccione un tipo de persona",
    "tipoDeIdentificacion": "Seleccione un tipo de identificación",
    "numeroIdentificacion": "Ingrese un número de identificación",
    "declarante": "Seleccione si es declarante",
    "representanteLegal": "Ingrese el nombre del representante legal",
    "identificacionRepresentante": "Ingrese n. identificación del representante legal",
    "pasivoCorriente": "Ingrese el valor de sus pasivos corrientes",
    "activoCorriente": "Ingrese el valor de sus activos corrientes",
    "tipoDeProveedor": "Seleccione un tipo de proveedor",
    "actividades": "Seleccione al menos una actividad",
    "codigoCiu": "Ingrese el código CIU",
    "cuentaBancaria": "Ingrese el número de la cuenta bancaria",
    "tipoDeCuenta": "Seleccione un tipo de cuenta",
    "banco": "Seleccione un banco",
    "correos": "Ingrese al menos una dirección de correo electrónico",
    "telefonos": "Ingrese un número teléfonico",
    "documentos": "Ingrese la documentación requerida"
  };

  validarInformacionRequerida(): string {
    const invalid = [];
    const controls = this.form.controls;
    let mensajeValidacion = '';

    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }

    if (invalid.length > 0 || this.direcciones.length <= 0 || this.contactos.length <= 0) {
      mensajeValidacion += '<ul style="list-style-type: none;">';

      invalid.forEach(e => {
        mensajeValidacion += `<li style='color: red'><strong>- ${this.mensajesValidacion[e]}</strong></li>`;
      });

      if (this.direcciones.length <= 0) {
        mensajeValidacion += `<li style='color: red'><strong>- Ingrese al menos una dirección</strong></li>`;
      }

      if (this.contactos.length <= 0) {
        mensajeValidacion += `<li style='color: red'><strong>- Ingrese al menos un dato de contacto</strong></li>`;
      }

      mensajeValidacion += '</ul>';
    }

    return mensajeValidacion;
  }

  abrirModalContacto(index?: number, contacto?: Contacto) {
    let options = {
      keyboard: true,
      ignoreBackdropClick: true,
      initialState: {
        titulo: (index >= 0 && contacto != null) ? 'Editar Contacto' : 'Agregar Contacto'
      }
    }

    this.bsModalRef = this.modalService.show(ContactoFormComponent, options);
    this.bsModalRef.content.nombreBotonCerrar = 'Cerrar';

    if (index >= 0 && contacto != null) {
      this.bsModalRef.content.getContacto(contacto);
    }

    this.bsModalRef.content.onCerrar.subscribe(resultado => {
      if (index >= 0) {
        this.contactos[index] = resultado;
      }
      else {
        this.contactos.push(resultado);
      }
    });
  }

  eliminarContacto(index: number) {
    this.contactos.splice(index, 1);
  }

  abrirModalDireccion(index?: number, direccion?: Direccion) {
    let options = {
      keyboard: true,
      ignoreBackdropClick: true,
      initialState: {
        titulo: (index >= 0 && direccion != null) ? 'Editar Dirección' : 'Agregar Dirección'
      },
      class: 'modal-lg'
    }

    this.bsModalRef = this.modalService.show(DireccionFormComponent, options);
    this.bsModalRef.content.nombreBotonCerrar = 'Cerrar';

    if (index >= 0 && direccion != null) {
      this.bsModalRef.content.getDireccion(direccion);
    }

    this.bsModalRef.content.onCerrar.subscribe(resultado => {
      if (index >= 0) {
        this.direcciones[index] = resultado;
      }
      else {
        this.direcciones.push(resultado);
      }
    });
  }

  eliminarDireccion(index: number) {
    this.direcciones.splice(index, 1);
  }

  removerArchivo(index: number) {
    let ctrl = this.documentos.controls[index] as FormGroup;
    ctrl.controls.rutaArchivo.setValue(null);
    ctrl.controls.archivo.setValidators(Validators.required);
  }

  adjuntos = [];
  unMegabyteAbyte = 1048576;

  onFileChange(event, index) {
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      let ctrl = this.documentos.controls[index] as FormGroup;

      let tamanoArchivo = ctrl.controls.tamano.value || 20971520;

      if (file.size > tamanoArchivo) {
        ctrl.controls.archivo.setErrors({ maxSize: true });
      }
      else {
        ctrl.controls.archivo.setErrors(null);
      }

      this.adjuntos[index] = file;
    }
  }

  validarCamposRequeridos(tipoDePersona: number) {
    if (tipoDePersona == TipoDePersonaEnum.Natural) {
      this.form.controls.razonSocial.setValue('');
      this.form.controls.razonSocial.clearValidators();
    }
    else {
      this.form.controls.nombres.setValue('');
      this.form.controls.nombres.clearValidators();
      this.form.controls.apellidos.setValue('');
      this.form.controls.apellidos.clearValidators();
    }
  }

  compareActividades = (item, selected) => {
    console.log(item, selected)
    if (selected.categoria && item.categoria) {
      return item.categoria === selected.categoria;
    }
    if (item.id && selected.id) {
      return item.id === selected.id;
    }
    return false;
  };

  get mostrarBotonDescargarPlantillaAbonoEnCuenta() : boolean {
    let result = false;

    if (this.f.tipoDePersona.value == TipoDePersonaEnum.Juridica && this.f.numeroIdentificacion.value.length > 0 && this.f.razonSocial.value.length > 0 && this.f.tipoDeCuenta.value != null && this.f.banco.value != null && this.f.cuentaBancaria.value.length > 0) {
      result = true;
    }
    else if(this.f.tipoDePersona.value == TipoDePersonaEnum.Natural && this.f.numeroIdentificacion.value.length > 0 && this.f.nombres.value.length > 0 && this.f.apellidos.value.length > 0 && this.f.tipoDeCuenta.value != null && this.f.banco.value != null && this.f.cuentaBancaria.value.length > 0) {
      result = true;
    }

    return result;
  }

  descargarPlantillaAutorizacionAbonoEnCuenta() {
    let banco = this.bancos.filter(b => b.id == this.f.banco.value).map(b => b.nombre);
    let titular = this.f.tipoDePersona.value == TipoDePersonaEnum.Juridica ? this.f.razonSocial.value : `${this.f.nombres.value} ${this.f.apellidos.value}`;
    let identificacion = this.f.numeroIdentificacion.value;
    let personaNatural = this.f.tipoDePersona.value == TipoDePersonaEnum.Natural ? 'X' : '';
    let personaJuridica = this.f.tipoDePersona.value == TipoDePersonaEnum.Juridica ? 'X' : '';
    let cuentaDeAhorro = this.f.tipoDeCuenta.value == TipoDeCuentaEnum.Ahorro ? 'X' : '';
    let cuentaCorriente = this.f.tipoDeCuenta.value == TipoDeCuentaEnum.Corriente ? 'X' : '';
    let cuenta = this.f.cuentaBancaria.value;

    let urlParams = `titular=${titular}&identificacion=${identificacion}&personaNatural=${personaNatural}&personaJuridica=${personaJuridica}&cuentaDeAhorro=${cuentaDeAhorro}&cuentaCorriente=${cuentaCorriente}&banco=${banco[0]}&cuenta=${cuenta}`

    window.open(`/api/plantillas?${urlParams}`, '_blank');
  }

}
